<script setup lang="ts">
import { Form, Head, Link } from '@inertiajs/vue3';
import RegisteredUserController from '@/actions/App/Http/Controllers/Auth/RegisteredUserController';
import InputError from '@/components/InputError.vue';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import AuthLayout from '@/layouts/AuthLayout.vue';
import { login } from '@/routes';
</script>

<template>
    <AuthLayout title="Create your account" description="Start a 7-day explore trial — connect channels and schedule freely. AI unlocks when you subscribe.">
        <Head title="Sign up" />

        <Form v-bind="RegisteredUserController.store.form()" class="space-y-4" v-slot="{ errors, processing }">
            <div class="grid gap-2">
                <Label for="name">Name</Label>
                <Input
                    id="name"
                    name="name"
                    required
                    autofocus
                    autocomplete="name"
                    placeholder="Your name"
                />
                <InputError :message="errors.name" />
            </div>

            <div class="grid gap-2">
                <Label for="email">Email</Label>
                <Input
                    id="email"
                    type="email"
                    name="email"
                    required
                    autocomplete="username"
                    placeholder="you@company.com"
                />
                <InputError :message="errors.email" />
            </div>

            <div class="grid gap-2">
                <Label for="password">Password</Label>
                <Input
                    id="password"
                    type="password"
                    name="password"
                    required
                    autocomplete="new-password"
                    placeholder="••••••••"
                />
                <InputError :message="errors.password" />
            </div>

            <div class="grid gap-2">
                <Label for="password_confirmation">Confirm password</Label>
                <Input
                    id="password_confirmation"
                    type="password"
                    name="password_confirmation"
                    required
                    autocomplete="new-password"
                    placeholder="••••••••"
                />
                <InputError :message="errors.password_confirmation" />
            </div>

            <Button type="submit" class="w-full" :disabled="processing">
                Create account
            </Button>
        </Form>

        <p class="mt-6 text-center text-sm text-muted-foreground">
            Already have an account?
            <Link :href="login()" class="font-semibold text-foreground hover:underline">
                Log in
            </Link>
        </p>
    </AuthLayout>
</template>
